import { memo } from "react";
import { jsx } from "react/jsx-runtime";
//#region src/icons/icon-24-pause-solid.tsx
/**
* icon.24.pause.solid
*
* Keywords: vertical, bars, parallel, stop, halt, suspend, media, control
*
* ![](data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI2NCIgaGVpZ2h0PSI2NCIgZmlsbD0ibm9uZSIgdmlld0JveD0iMCAwIDI0IDI0Ij48cmVjdCB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIGZpbGw9IiMwMDAiIHJ4PSI0Ii8+PHBhdGggZmlsbD0iI2ZmZiIgZD0iTTkuNSA2QTEuNSAxLjUgMCAwIDEgMTEgNy41djlBMS41IDEuNSAwIDAgMSA5LjUgMThoLTJBMS41IDEuNSAwIDAgMSA2IDE2LjV2LTlBMS41IDEuNSAwIDAgMSA3LjUgNnptNyAwQTEuNSAxLjUgMCAwIDEgMTggNy41djlhMS41IDEuNSAwIDAgMS0xLjUgMS41aC0yYTEuNSAxLjUgMCAwIDEtMS41LTEuNXYtOUExLjUgMS41IDAgMCAxIDE0LjUgNnoiLz48L3N2Zz4=)
*
* https://staging.figma.com/file/ycDPAaAih2bZY5LgXehVai/?node-id=15311-40447
*/
const Icon24PauseSolid = memo(function Icon24PauseSolid(props) {
	return /* @__PURE__ */ jsx("svg", {
		width: "24",
		height: "24",
		fill: "none",
		viewBox: "0 0 24 24",
		...props,
		"data-fpl-icon-size": "24",
		children: /* @__PURE__ */ jsx("path", {
			fill: "var(--fpl-icon-color, var(--color-icon))",
			d: "M9.5 6A1.5 1.5 0 0 1 11 7.5v9A1.5 1.5 0 0 1 9.5 18h-2A1.5 1.5 0 0 1 6 16.5v-9A1.5 1.5 0 0 1 7.5 6zm7 0A1.5 1.5 0 0 1 18 7.5v9a1.5 1.5 0 0 1-1.5 1.5h-2a1.5 1.5 0 0 1-1.5-1.5v-9A1.5 1.5 0 0 1 14.5 6z"
		})
	});
});
//#endregion
export { Icon24PauseSolid };

//# sourceMappingURL=icon-24-pause-solid.js.map